import { Routes } from '@angular/router';

import { FormOverviewComponent } from './forms/form-overview/form-overview.component';
import { FormularAComponent } from './forms/formular-a/formular-a.component';
import { FormularKComponent } from './forms/formular-k/formular-k.component';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { iframeOnlyGuard } from './integration/fhco-post-message/iframe-only.guard';
import { localOnlyGuard } from './integration/fhco-post-message/local-only.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: FormOverviewComponent,
    canActivate: [localOnlyGuard]
  },
  {
    path: 'forms/form-a',
    component: FormularAComponent,
    canActivate: [iframeOnlyGuard]
  },
  {
    path: 'forms/form-k',
    component: FormularKComponent,
    canActivate: [iframeOnlyGuard]
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: '**',
    redirectTo: 'access-denied'
  }
];
